import React from 'react';
import { Row } from '../../../atoms/row/Row';
import { Star } from '../../../../../static/icons/star';

const getValueForStar = (itemValue, starIndex) => {
  const difference = itemValue - starIndex;
  if (difference >= 1) {
    return 1;
  }
  return difference;
};

const StarRating = ({
  fillColor,
  emptyColor,
  width,
  height,
  rating,
  ...props
}) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Row {...props}>
    {[...Array(5)].map((_, i) => (
      <Star
        key={i}
        width={width}
        height={height}
        fillColor={fillColor}
        emptyColor={emptyColor}
        value={getValueForStar(rating, i)}
      />
    ))}
  </Row>
);

export default StarRating;
